import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
// import SearchIcon from "@mui/icons-material/Search";
// import { Button } from "@mui/material";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import LockResetIcon from '@mui/icons-material/LockReset';
import swal from "sweetalert";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import "./addmin.css";
import { deleteUserData, getMeber, resetPassword, getActivePlan, getcomanyUpdate, comanyUpdate } from "../WorkSpace/Components/ApiServices/apiHandler";
import { getProfile } from "../services/api/apiHandler";
import AdminNavbar from "./Components/AdminNavbar";
import { generatePassword } from "../helper/accessibility";
import Loading from "../Components/Common/Loader/Loading";
import Sidebar from "../myfin_v2/elements/Sidebar";
import Modal from "../myfin_v2/elements/Modal";
import modalcss from "../myfin_v2/css/modal.module.css";
import buttoncss from "../myfin_v2/css/button.module.css";
import adminPortalCss from "../myfin_v2/css/adminportal.module.css";
import commoncss from "../myfin_v2/css/common.module.css";
import { Button } from "../myfin_v2/elements/Button";
import InputGroup from "../myfin_v2/elements/InputGroup";
import SuccessModal from "../myfin_v2/components/connections/SuccessModal";
import ErrorModal from "../myfin_v2/components/connections/ErrorModal";
import { ReactComponent as WarningIcon } from "../myfin_v2/assets/icons/warning.svg";
import { ReactComponent as SearchIcon } from "../myfin_v2/assets/icons/search.svg";
import { ReactComponent as PrimaryDeleteIcon } from "../myfin_v2/assets/icons/delete_icon_primary.svg";
import { ReactComponent as PlusPrimaryIcon } from "../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as EditIconWhite } from "../myfin_v2/assets/icons/editWhite.svg";
import { ReactComponent as DeleteIconRed } from "../myfin_v2/assets/icons/delete_red.svg";
import { ReactComponent as CloseIcon } from "../myfin_v2/assets/icons/close.svg";
import { ReactComponent as CloseGreyIcon } from "../myfin_v2/assets/icons/close_grey.svg";
import { ReactComponent as AddCardTopIcon } from "../myfin_v2/assets/icons/addCardsTopActiveIcon.svg";
import { ReactComponent as GlobeIcon } from "../myfin_v2/assets/icons/globe.svg";
import { ReactComponent as NoMemberIcon } from "../myfin_v2/assets/icons/noMember.svg";
import DefaultMemberImage  from "../myfin_v2/assets/imgs/defaultMember.png";

const Admin = () => {
	const history = useHistory();

	const [users, setUsers] = useState([]);
	const [allUsers, setAllUsers] = useState([]);
	const [loading, setLoading] = useState(false);
	const [userNo, setUserno] = useState('');
	const [displayModal, setDisplayModal] = useState(false);
	const [deleteMemberModal, setDeleteMemberModal] = useState(false);
	const [selectedUserId, setSelectedUserId] = useState(null);
	const [showSearch, setShowSearch] = useState(false);
  	const [searchText, setSearchText] = useState("");
	const [expanded, setExpanded] = useState(false);
	const [domain, setDomainData] = useState({domain: ""});
	const [domainUpdateModal, setDomainUpdateModal] = useState(false)
	const [userID, setUserID] = useState(null);
	const [showSuccessToaster, setShowSuccessToaster] = useState(false);
	const [successMessage, setSuccessMessage] = useState("");
	const [showErrorToaster, setShowErrorToaster] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");


	useEffect(() => {
		fetchMember();
		activePlandata();
		getUserID();
	}, [])	


	const fetchMember = async () => {
		setLoading(true);
		getMeber().then(response => {
			setAllUsers(response.data.fetchMember);
			setUsers(response.data.fetchMember);
			setLoading(false);
		}).catch(error => {
			setLoading(false);
			swal(
				"Error",
				error.response?.data?.error || "Getting member data failed!",
				"error"
			);
		})
	};

	const getUserID = async () => {
		try {
			const profileData = await getProfile();
			
			setUserID(profileData.data.user.data._id)
		}catch (error) {
			console.log(error, 'errorr')
		}
	}

	const activePlandata = async () => {
		try {
			const res = await getActivePlan()
			console.log(res, 'activeplandata')
			setUserno(res.data.categorizedBenefits.noOfUsers[0]);

			console.log(res.data.users, 'no of users')
		} catch (error) {
			console.log(error, 'errorr')
		}
	}

	const ResetPassword = (userId) => {
		const tempPassword = generatePassword();
		swal({
			title: 'Are you sure?',
			text: 'Once Reset, User will not be able to login with previous password!',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(() => {
			resetPassword({
				tempPassword,
				userId
			}).then(response => {
				swal({
					title: 'Reset!',
					text: 'Password has been reset. Check your mail for your new password!',
					icon: 'success'
				});
				fetchMember();
			}).catch(error => {
				swal(
					"Error",
					error.response?.data?.error || "Getting member data failed!",
					"error"
				);
			})
		});
	}

	const DeleteMember = (userId) => {
		swal({
			title: "Are you sure?",
			text: "You will not be able to recover this file!",
			icon: "warning",
			buttons: ["Cancel", "Yes, delete it!"],
			closeOnClickOutside: false,
		}).then((willDelete) => {
			if (willDelete) {
				deleteUserData(userId).then(response => {
					toast.success("Team Member Deleted Successfully.");
					fetchMember();
				}).catch(error => {
					swal(
						"Error",
						error.response?.data?.error || "Team member delete failed!",
						"error"
					);
				});
			} else {
				toast.info("Action cancelled.");
			}
		});
	};

	const handleDeleteMember = async (userId) => {
		try {
			await deleteUserData(userId);
			setDisplayModal(false);
			setDeleteMemberModal(false);
			fetchMember();

			toast.success("Team Member Deleted Successfully.");
		} catch (error) {
			toast.error(error.response?.data?.error || "Team member delete failed!");
		}
	}


	const HandleSearch = (targetEvent) => {
		const { value } = targetEvent;
		if (value.length > 0) {
			const filteredData = allUsers.filter(item =>
				item.name.toLowerCase().includes(value.toLowerCase()) ||
				item.email.toLowerCase().includes(value.toLowerCase())
			);
			setUsers(filteredData);
		} else {
			setUsers(allUsers);
		}
	}

	const openSearch = () => {
		setShowSearch(true);
	};

	const closeSearch = () => {
		setExpanded(false);
		setTimeout(() => setShowSearch(false), 600);
		setSearchText("");
	};

	useEffect(() => {
		if (showSearch) {
			const timeout = setTimeout(() => setExpanded(true), 15);
			return () => clearTimeout(timeout);
		} else {
			setExpanded(false);
		}
	}, [showSearch]);


	const getUpdateDomain = async (id) => {
		try {
			const domaindata = await getcomanyUpdate(userID)
			if (domaindata.status === 200) {
				setDomainData({
					domain: domaindata.data.data.domain
				})

			}

		} catch (error) {
			console.log(error);
		}
	}

	const handledomainChange = (id, e) => {
		const { name, value } = e.target;
		setDomainData({ ...domain, [name]: value })
	}

	const handleDomainUpdate = async (e) => {
		e.preventDefault();
		try {

			const data = {
				domain: domain.domain,
				user_id: userID
			}

			const companydata = await comanyUpdate(data)

			if (companydata.status === 200) {
				showToaster("Domain Updated", "success")
				setDisplayModal(false);
				setDomainUpdateModal(false);
			}

		} catch (error) {
			console.log(error)
		}

	}

	const showToaster = (message, type) => {
        if (type === "success") {
            setSuccessMessage(message);
            setShowSuccessToaster(true);
            setTimeout(() => {
                setShowSuccessToaster(false);
                setSuccessMessage("");
            }, 3000); // Hide after 3 seconds
        } else if (type === "error") {
            setErrorMessage(message);
            setShowErrorToaster(true);
            setTimeout(() => {
                setShowErrorToaster(false);
                setErrorMessage("");
            }, 3000); // Hide after 3 seconds
        }
    };

	const handleCloseSuccessToaster = () => {
        setShowSuccessToaster(false);
        setSuccessMessage("");
    };

    const handleCloseErrorToaster = () => {
        setShowErrorToaster(false);
        setErrorMessage("");
    };

	return (
		<>
			{/* <AdminNavbar /> */}
			<div className={adminPortalCss.dFlex}>
				<Sidebar />
				
					<div className={`${adminPortalCss.adminPortalLayout}`}>
						<div className={adminPortalCss.apDataLayout}>
							<div className={adminPortalCss.apHeader}>
								<span className={adminPortalCss.apHeaderTitle}>
									Admin Portal
								</span>
								<span className={adminPortalCss.teamWarningMsg}>
									<WarningIcon height={20} width={20} /> You can create maximum <span style={{fontWeight:"700"}}> {userNo} </span> Team Members!
								</span>
								<div className={adminPortalCss.apHeaderRightItems}>

									<div className={adminPortalCss.searchWrapper}>

										{!showSearch && (
											<SearchIcon onClick={openSearch} style={{cursor:"pointer"}} />
										)}

										{showSearch && (
											
											<div className={`${adminPortalCss.searchBox} ${expanded ? adminPortalCss.expanded : ""}`}>
												<SearchIcon className={adminPortalCss.searchInside}/>
												<input
													type="text"
													value={searchText}
													onChange={(e) => setSearchText(e.target.value)}
													placeholder="Search..."
													className={adminPortalCss.searchInput}
												/>
												<CloseGreyIcon
													style={{cursor:"pointer"}}
													onClick={closeSearch}
												/>
											</div>
										)}
									</div>

									<button className={adminPortalCss.outlinedBtns}
										onClick={() => {
											getUpdateDomain();
											setDisplayModal(true);
											setDomainUpdateModal(true);
										}}
									>
										<GlobeIcon /> Domain
									</button>
									<button className={adminPortalCss.outlinedBtns}
										onClick={() => history.push('/deleted-Ids')}
									>
										<PrimaryDeleteIcon /> Bin
									</button>
									<button 
										className={adminPortalCss.outlinedBtns}
										style={{backgroundColor:"#F4FAF5"}}
										onClick={() => history.push("/add-teamate")}
									>
										<PlusPrimaryIcon /> Add Member
									</button>
								</div>
							</div>
							<div className={adminPortalCss.apContent}>
								<motion.div
									initial={{ x: 200, opacity: 0 }}
									animate={{ x: 0, opacity: 1 }}
									exit={{ x: 200, opacity: 0 }}
									transition={{ duration: 1, ease: "easeInOut" }}
									className="w-100"
								>
									<div className={adminPortalCss.apMembersView}>
										{users.length > 0 ? (
											<>
											{users
												.filter(user =>
												user.name.toLowerCase().includes(searchText.toLowerCase()) ||
												user.email.toLowerCase().includes(searchText.toLowerCase())
												)
												.map((user, userIndex) => (
												<div
													key={user._id}
													className={adminPortalCss.userCard}
													onClick={() => history.push(`add-teamate/${user._id}`)}
												>
													<img
													src={user.profile_img_url || DefaultMemberImage}
													alt="profile_img"
													className={adminPortalCss.userImage}
													onError={(e) => {
														e.target.onerror = null;
														e.target.src = DefaultMemberImage;
													}}
													/>
													<div className={adminPortalCss.overlay}>
													<RoleIndicator role={user.responsibilities} />
													<span className={adminPortalCss.userName}>{user.name}</span>
													<span className={adminPortalCss.userEmail}>{user.email}</span>
													<div className={adminPortalCss.userActions}>
														<span>
														<EditIconWhite />
														</span>
														<span
														onClick={(e) => {
															e.stopPropagation();
															setSelectedUserId(user._id);
															setDisplayModal(true);
															setDeleteMemberModal(true);
														}}
														>
														<DeleteIconRed />
														</span>
													</div>
													</div>
												</div>
												))}

											{/* Add Member Card only when users exist */}
											<div
												className={adminPortalCss.addMemberCard}
												onClick={() => history.push("/add-teamate")}
											>
												<AddCardTopIcon className={adminPortalCss.topRightIcon} />
												<div className={adminPortalCss.aMcardText}>
												<span>Add</span>
												<br />
												<span>new</span>
												<br />
												<span>member</span>
												</div>
											</div>
											</>
										) : (
											// Default screen when no users
											<div className={adminPortalCss.noMembersContainer}>
												<NoMemberIcon />
												<span className={adminPortalCss.noMemberText}>No members added yet, Click on add members <br /> button to add a member</span>
											</div>
										)}
										</div>

								</motion.div>
							</div>
							{deleteMemberModal && displayModal && (
							<Modal
								headerActions={
									<CloseIcon
									onClick={() => {
										setDisplayModal(false);
										setDeleteMemberModal(false);
										setSelectedUserId(null);
									}}
									className="clickable"
									/>
								}
								headerBottomLine={false}
								onClose={() => console.log("Modal Closed")}
								>
								<span className={`${modalcss.modalBodyHead} mb-1`}>
									Do you want to <span className="fw700">delete</span> the
									member?
								</span>
								<span
									className={`${modalcss.modalBodycnt}`}
									style={{ "margin-bottom": "35px" }}
								>
									You can restore the deleted members
								</span>
								<span
									className={`${modalcss.modalBodycnt} ${modalcss.modalBodyBtns}`}
								>
									<Button
										btnColor={buttoncss.danger}
										label="Yes, Delete"
										onClick={() => {
											handleDeleteMember(selectedUserId);
											setDisplayModal(false);
											setDeleteMemberModal(false);
											setSelectedUserId(null);
										}}
									/>
									<Button
										btnColor={buttoncss.secondary_del}
										label="No, Cancel"
										onClick={() => {
											setDisplayModal(false);
											setDeleteMemberModal(false);
										}}
									/>
								</span>
								</Modal>
							)}
							{domainUpdateModal && displayModal && (
							<Modal
								title="Domain"
								bodycss={commoncss.unsetPadding}
								headerActions={
									<CloseIcon
									onClick={() => {
										setDisplayModal(false);
										setDomainUpdateModal(false);
									}}
									className="clickable"
									/>
								}
								footerActions={
									<>
										<Button
											btnColor={buttoncss.secondary}
											onClick={() => {setDomainUpdateModal(false)}}
											label="Cancel"
										/>
										<Button
											btnColor={buttoncss.primary}
											label="Save"
											onClick={(e) => {
												handleDomainUpdate(e);
											}}
										/>
									</>
								}
								>
								<div className={commoncss.pd1530}>
									<InputGroup
										label="Domain"
										inputs={[
										<>
											<input
												type="text"
												name='domain'
												value={domain.domain}
												onChange={(e) => handledomainChange(domain, e)}
											/>
										</>,
										]}
									/>
									</div>
								</Modal>
							)}
							{showSuccessToaster && (
								<SuccessModal
									handleClose={handleCloseSuccessToaster}
									setSuccessModal={setShowSuccessToaster} 
									setSuccessMessage={setSuccessMessage} 
									successMessage={successMessage}
									bodycls=""
								/>
							)}
				
							{showErrorToaster && (
								<ErrorModal
									handleClose={handleCloseErrorToaster}
									setErrorModal={setShowErrorToaster} 
									setErrorMessage={setErrorMessage}
									errorMessage={errorMessage}
								/>
							)}
						</div>
						{/* <div className="px-3">
				<div className="d-flex justify-content-between mt-3">
				<p className="mt-0 mb-0 custom-font-600 font-size-20 font-sans">
					Admin Portal
				</p>
				<span className="mt-3">You can create maximum <span style={{color:'red'}}>{userNo}</span> Team Members! </span>
				<div className="d-flex">
					<div className="search-btnv2 d-flex flex-row jusify-content-center align-items-center radius-10px">
					<SearchIcon style={{ color: "gray" }} />
					<input
						className="w-100 border-0 text-secondary"
						placeholder="Search by User name or Email ID"
						onChange={(e) => HandleSearch(e.target)}
					/>
					</div>
					<Button
					variant="outlined"
					className="font-size-16 custom-font-600 primary-border custom-common-theme-text-color text-capitalize font-sans radius-6px ml-2"
					style={{ height: "48px" }}
					onClick={() => history.push("/deleted-Ids")}
					>
					Deleted Members
					</Button>
					{users.length >= userNo ? (
					<Button
					variant="outlined"
					className="font-size-16 custom-font-600 primary-border custom-common-theme-text-color text-capitalize font-sans radius-6px ml-2"
					style={{ height: "48px" }}
					onClick={() => swal("","You have reached maximum no of create Team Members","warning")}
					>
					Add teammate
					</Button>):(<Button
					variant="outlined"
					className="font-size-16 custom-font-600 primary-border custom-common-theme-text-color text-capitalize font-sans radius-6px ml-2"
					style={{ height: "48px" }}
					onClick={() => history.push("/add-teamate")}
					>
					Add teammate
					</Button>)}
					
				</div>
				</div>

				{
				loading ? <Loading /> :
				<table className="custom-table mt-2 w-100">
					<thead className="custom-bg-white-150" >
					<tr>
						<th className="text-uppercase font-size-12 custom-font-600 font-inter border-top-left-radius text-left text-secondary">
						SL.NO
						</th>
						<th className="text-uppercase font-size-12 custom-font-600 font-inter text-left text-secondary" style={{ minWidth: "150px" }}>
						User Name
						</th>
						<th className="text-uppercase font-size-12 custom-font-600 font-inter text-left text-secondary" style={{ minWidth: "150px" }}>
						Email
						</th>
						<th className="text-uppercase font-size-12 custom-font-600 font-inter text-left text-secondary" style={{ minWidth: "120px" }}>
						Temp Password
						</th>
						<th className="text-uppercase font-size-12 custom-font-600 font-inter text-left text-secondary" style={{ minWidth: "150px" }}>
						Responsibilities
						</th>
						<th className="text-uppercase font-size-12 custom-font-600 font-inter text-center text-secondary" style={{ width: "22rem" }} >
						Action
						</th>
					</tr>
					</thead>
					<tbody>
					{
						users.length > 0 ? users.map((user, userIndex) => (
						<tr
							// className="last-row" 
							key={userIndex}
						>
							<td className="bg-white text-center text-secondary font-size-14"> {userIndex + 1} </td>
							<td className="bg-white text-left pl-2 text-secondary font-size-14 text-capitalize"> {user.name} </td>
							<td className="bg-white text-left pl-2 text-secondary font-size-14"> {user.email} </td>
							<td className="bg-white text-left pl-2 text-secondary font-size-14"> {user.temp_password} </td>
							<td className="bg-white text-left pl-2 text-secondary font-size-14"> {user.responsibilities} </td>
							<td className="bg-white text-center pl-2 text-secondary d-flex justify-content-center h-100">
							<button 
								className="d-flex justify-content-center align-items-center bg-color-inherit border-0"
								onClick={() => history.push(`add-teamate/${user._id}`)}
							>
								<div>
								<DriveFileRenameOutlineIcon
								className="custom-common-theme-text-color h-50"
								/></div>
								<p className="mt-0 mb-0 font-size-14 custom-common-theme-text-color custom-font-600">
								Edit
								</p>
							</button>

							<button 
								className="d-flex justify-content-center align-items-center bg-color-inherit border-0 ml-2"
								onClick={() => DeleteMember(user._id)}
							>
								<div>
								<DeleteOutlineIcon
								className="text-danger h-50"
								/></div>
								<p className="mt-0 mb-0 font-size-14 custom-font-600 text-danger">
								Delete
								</p>
							</button>

							<button
								className="d-flex justify-content-center align-items-center bg-color-inherit border-0 ml-2"
								onClick={() => ResetPassword(user._id)}
							>
								<div>
								<LockResetIcon
								className="text-success h-50"
								/></div>
								<p className="mt-0 mb-0 font-size-14 custom-font-600 text-success">
								Reset Password
								</p>
							</button>
							</td>
						</tr>
						)) : 
						<tr > 
						<td colSpan={6} className="text-secondary font-size-14" > Data Not Found  </td>
						</tr>
					}
					</tbody>
				</table>
				}
			</div> */}
					</div>
			</div>
		</>
	);
};

export default Admin;


const RoleIndicator = ({role}) => {


	const getRoleClass = (role) => {
		switch (role.toLowerCase()) {
		case "admin":
			return adminPortalCss.roleAdmin;
		case "preparer":
			return adminPortalCss.rolePreparer;
		case "appropver":
			return adminPortalCss.roleApprover;
		default:
			return adminPortalCss.defaultRole;
		}
	};

	return(
		<span className={`${adminPortalCss.roleIndicator} ${getRoleClass(role)}`}>
			{role}
		</span>
	)
}